import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_LIST = (params) => {
  return axiosIns.get(`/sites?${params}`);
};

export const CREATE_DATA = (payload) => {
  return axiosIns.post("/site/create", payload);
};

export const UPDATE_DATA = (id, payload) => {
  return axiosIns.put(`/site/${id}/update`, payload);
};

export const REMOVE_DATA = (id) => {
  return axiosIns.delete(`/site/${id}/delete`);
};
